import React from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { Icon } from 'js/components/common/Icon';

import * as Types from './types';

import style from './ClearInputIcon.scss';

export const ClearInputIcon: React.FC<Types.IClearInputIconProps> = ({
    className = '',
    animate = false,
    onClick
}) => {
    const translate = useTranslations();

    return (
        <Icon
            onClick={onClick}
            type={'clearInputIcon'}
            aria-label={translate('playtech.mobile.system.input.clear.aria-label')}
            className={`${style.icon} ${className} ${animate ? 'showBounceIn' : ''}`}
        />
    );
};

export default ClearInputIcon;
